import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf26.png';

const MarketShareStep15 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        Since your team did not hit your market share this past round, we highly
        recommend you conduct further Research and revisit the business case to
        understand the most optimal sales channel given the customers that you
        are targeting.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep15;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step15.js